module.exports = __webpack_public_path__ + "img/more-vertical-v2.4bee60eb.svg";